import { Dialog, DialogContent } from '@material-ui/core';
import React from 'react'
import { useMedia } from 'react-use';
import styled from 'styled-components';
import { Flex, TextWrapper } from '../../layout/reusables';
import { colors } from '../../styles/colors';
import { BodyText } from '../../styles/typography';

export const ViewModalHeaderSection = ({ image, name, handleClose }) => {
    return (
        <Flex style={{background: 'white', top: 0, position: 'sticky', borderBottom: '1px solid #eee', padding: '20px 0', width: '100%'}} direction="row" align="center" justify="space-between">
            <Flex style={{marginLeft: 20}} direction="row" align="center" justify="flex-start">
                <img alt={`${name}-logo`} src={image} style={{objectFit: 'cover', border: '2px solid yellow', marginRight: 10, width: 40, borderRadius: 20, height: 40}} />
                <BodyText fontSize={18}>{name}</BodyText>
            </Flex>
            <TextButton style={{marginRight: 20}} onClick={handleClose}>Close</TextButton>  
        </Flex>
    )
}

export default function PhotoViewerModal({ open, setOpen, photo, name, logo, handleClose }) {
    
    const isMobile = useMedia("(max-width: 600px)")
    
    const handleCloseModal = () => {
        setOpen(false)
    }

    
    return (
        <Dialog
            open={open}
            onClose={handleCloseModal}
            fullWidth={true}
            maxWidth="md"
            fullScreen={isMobile ? true : false}
        >
            <DialogContent style={{padding: '0 0 20px 0'}}>
                
                <Container>
                    <ViewModalHeaderSection name={name} image={logo} handleClose={handleCloseModal}/>
                    <Image
                        src={photo.url}
                    />
                    <TextWrapper style={{textAlign: 'center'}}>
                        <Title>{photo.title}</Title>
                        <Description>{photo.description}</Description>
                    </TextWrapper>
                </Container>
            </DialogContent>
        </Dialog>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const Title = styled.h1`
    font-size: 32px;
    line-height: 1.3;
    margin-bottom: 10px;
    font-weight: 500;
    text-align: left;
    color: black;
    text-align: center;
    font-family: 'Quattrocento';
    font-weight: 400;

    @media (max-width: 550px) {
        font-size: 22px;
    }
`
const Description = styled.p`
    opacity: 0.8;
`;
const Image = styled.img`
    height: 100%;
    max-height: 70vh;
    width: 100%;
    margin-bottom: 20px;
    object-fit: contain;
`;
const TextButton = styled.button`
    border: none;
    outline: none;
    background: none;
    cursor: pointer;
    font-family: "Haas";
    font-weight: 500;
    color: ${colors.blue};
    font-size: 16px;
`;
